import React, { FC } from 'react';
import { Typography, Skeleton, Box, SkeletonProps } from '@dxb-web-ui-framework/design-system';
import { GenericObject } from '@dxb-web-ui-framework/common/types';

//TODO: add correct types typographyProps ask DS to export them
export interface SkeletonTypographyProps {
  hasSkeleton?: boolean;
  skeletonProps?: SkeletonProps;
  typographyProps?: GenericObject;
}

const SkeletonTypography: FC<SkeletonTypographyProps> = ({
  hasSkeleton,
  skeletonProps = { variant: 'text', width: 'fit-content', height: 'fit-content' },
  typographyProps,
  children,
}) => {
  if (hasSkeleton) {
    return (
      <Skeleton {...skeletonProps}>
        <Box visibility='none'>{children}</Box>
      </Skeleton>
    );
  }

  return <Typography {...typographyProps}>{children}</Typography>;
};

export { SkeletonTypography };
